import { EditOutlined } from "@ant-design/icons";
import { Button, ConfigProvider, Pagination, PaginationProps, Switch, Tooltip } from "antd"
import viVN from 'antd/locale/vi_VN';
import { useEffect, useMemo, useState } from "react";
import { dataPagination, fommatSelectOption, getPermissionClass, getUserPermissions } from "../../../../until";
import ModalCreateZNS from "../Modal/ModalCreateZNS";
import useThrottle from "../../../../hook/useThrottle";
import useToast from "../../../../hook/useToast";
import { formatNumber } from "../../../../services/mixin";
import ModalZNSSupplierManagement from "./ModalZNS/ModalZNSSupplierManagement";
import { IPagination } from "../../../Customers/CustomerGroup/Component/AddGroup/AddNewGroup";
import useDebounce from "../../../../hook/useDebounce";
import useLoading from "../../../../hook/useLoading";
import { activeConfig, getInfoZnsConfig, getListZnsConfig, IBrandConfigsZNS, IZnsConfig } from "../../../../api/integrationProvider/integrationProvidersApi";
import { getCLCategoryCar } from "../../../../api/selectOption/selectOptionsApi";
import { useSelector } from "react-redux";
import { selectorCategoryCarIds } from "../../../../store/slices/categoryCarSlice";
import { ISelectOption } from "../../../../api/selectOptions/selectOptionsApi";
import ModalUpdateZNS from "../Modal/ModalUpdateZNS";
import { ColDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { NodataTable } from "../../../../components/NoDataTable";
import { useLocation } from "react-router-dom";
import { selectorPermission } from "../../../../store/slices/permissionSlice";
import { NO_VIEW } from "../../../../services/data";

interface PropZNS {

}

const ZNSGeneralConfiguration: React.FC<PropZNS> = ({

}) => {

  useEffect(() => {
    gListZnsConfig()
    gSLCategoryCar()
  }, [])

  const pushToast = useToast()
  const pushLoading = useLoading()

  const location = useLocation()
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, upload, download } = getUserPermissions(permissionSlice, location.pathname)
  const columnDefs = useMemo<ColDef<IBrandConfigsZNS>[]>(() => [
    {
      headerName: 'Hành động',
      field: 'id',
      width: 150,
      sortable: false,
      resizable: false,
      suppressMovable: true,
      lockPosition: 'left',
      cellRenderer: (params: any) => {
        const record = params.data;
        if (!record) return null;
        return (
          <div className="d-flex gap-2 align-center h-full">
            <Switch
              checked={Boolean(record.status)}
              className="rs-switch rs-switch--sm"
              onChange={() => onActiveConfig(Number(record.id))}
            />
            <EditOutlined
              className={` ${getPermissionClass(edit)} text-sm border-D9D9D9 p-5-px bg-white rounded-2`}
              onClick={() => openModalEditZNS(Number(record.id))}
            />
          </div>
        );
      },
    },
    {
      headerName: 'Brandname',
      field: 'brandName',
      minWidth: 180,
      flex: 1,
    },

    {
      headerName: 'Thương hiệu',
      field: 'categories',
      minWidth: 180,
      flex: 1,
    },

    {
      headerName: 'Phạm vi hoạt động',
      field: 'units',
      minWidth: 180,
      flex: 1,
      cellRenderer: (params: any) => (
        <Tooltip title={params.value}>
          <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
            {params.value}
          </span>
        </Tooltip>
      ),
    },
    {
      headerName: 'Username',
      field: 'smtpUsername',
      minWidth: 150,
      cellRenderer: (params: any) => (
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
         {NO_VIEW}
        </span>
      ),
    },
    {
      headerName: 'Password',
      field: 'smtpPassword',
      minWidth: 150,
      cellRenderer: (params: any) => (
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'block' }}>
         {NO_VIEW}
        </span>
      ),
    },
    {
      headerName: 'Ngày kết nối',
      field: 'connectDate',
      minWidth: 150,
    },
  ], []);

  const permittedCategoryCarIds = useSelector(selectorCategoryCarIds)

  const [openCreateZNS, setOpenCreateZNS] = useState(false)
  const [openEditZNS, setOpenEditZNS] = useState(false)
  const [isModalSupplierManagement, setIsModalSupplierManagement] = useState(false)

  const [sLCategoryCar, setSLCategoryCar] = useState<ISelectOption[]>([])

  const [pagination, setPagination] = useState<IPagination>({ current: 1, pageSize: 20, total: 0 })

  const [infoZnsConfig, setInfoZnsConfig] = useState<IZnsConfig>()
  const [listZnsConfig, setListZnsConfig] = useState<IBrandConfigsZNS[]>([])

  //#region gọi api SL OP


  const gSLCategoryCar = async () => {
    const result = await getCLCategoryCar(
      undefined, undefined, permittedCategoryCarIds
    )
    if (result?.status) {
      setSLCategoryCar([
        { label: "Tất cả", value: -1 },
        ...fommatSelectOption(result.data)
      ])
    }
  }
  //#endregion

  const gListZnsConfig = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true)
    const result = await getListZnsConfig(pageSize, pageCurent)
    if (result?.status) {
      setListZnsConfig(result.data)

      setPagination({ current: pageCurent, pageSize, total: result.total })
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)


  //#region modal
  const onActiveConfig = useThrottle(async (id: number) => {
    pushLoading(true)
    const result = await activeConfig(id);
    if (result?.status) {
      gListZnsConfig?.(pagination.current, pagination.pageSize)
      pushToast(result.message, "success", 2000)
    } else {
      pushToast(result.message, "error", 2000)
    }
    pushLoading(false)
  }, 2000)

  const onSubmitFormModalAdd = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setOpenCreateZNS(false)
      pushToast(message, "success")
      gListZnsConfig?.(pagination.current, pagination.pageSize)
    } else {
      pushToast(message, "error")
    }
  }

  const openModalEditZNS = useThrottle(async (id: number) => {
    pushLoading(true)
    const result = await getInfoZnsConfig(id);
    if (result?.status) {
      setInfoZnsConfig(result.data)
      setOpenEditZNS(true)
    } else {
      pushToast(result.message, "error", 2000)
    }
    pushLoading(false)
  }, 2000)

  const onSubmitFormModalUpdate = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setOpenEditZNS(false)
      pushToast(message, "success")
      gListZnsConfig?.(pagination.current, pagination.pageSize)
    } else {
      pushToast(message, "error")
    }
  }

  //#endregion

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    gListZnsConfig?.(pageNumber, pageSize)
  }



  return (
    <div className="custom-page-css flex flex-col flex-1 gap-18-px pt-2">

      <ModalCreateZNS
        isOpen={openCreateZNS}
        sLCategoryCar={sLCategoryCar}
        onSubmitFormModal={onSubmitFormModalAdd}
        closeModal={() => setOpenCreateZNS(false)}
      />

      <ModalUpdateZNS
        isOpen={openEditZNS}
        sLCategoryCar={sLCategoryCar}
        infoZnsConfig={infoZnsConfig}
        onSubmitFormModal={onSubmitFormModalUpdate}
        closeModal={() => setOpenEditZNS(false)}
      />


      <ModalZNSSupplierManagement
        isOpen={isModalSupplierManagement}
        closeModal={() => setIsModalSupplierManagement(false)}

        gListZnsConfig={gListZnsConfig}
      />
      <div className="d-flex align-center justify-between">
        <span className="font-medium fsz-16 lh-24">Thông tin tích hợp</span>
        <div className="custom-page-css flex items-center gap-2">
          {/* <Button className=" custom-page-css border rounded px-2"
            onClick={() => setIsModalSupplierManagement(true)}
          >
            <span>Quản lý nhà cung cấp</span>
          </Button> */}
          <Button

            className={` ${getPermissionClass(add)} `}
            type="primary"
            onClick={() => setOpenCreateZNS(true)}
          >
            Tạo mới
          </Button>
        </div>
      </div>
      <div className="custom-page-css flex flex-col flex-1 justify-between">
        <div className="ag-theme-alpine custom-table-ag-v2" style={{ width: '100%' }}>
          <AgGridReact<IBrandConfigsZNS>
            domLayout="autoHeight"
            rowData={listZnsConfig}
            columnDefs={columnDefs}
            defaultColDef={{ resizable: true, sortable: false }}
            tooltipShowDelay={0}
            suppressMovableColumns
            suppressCellFocus
            rowHeight={55}
            getRowId={(p) => String(p.data.id)}
            overlayNoRowsTemplate={NodataTable}
            getRowStyle={(params) => ({
              backgroundColor: params.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
          />
        </div>

        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination
              showSizeChanger
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
              itemRender={(page, type, originalElement) => {
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationChange}

            />
          </div>
        </ConfigProvider>
      </div>
    </div>
  )
}
export default ZNSGeneralConfiguration
